var _defs, _rect, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAqaSettingscol(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    width: 18,
    height: 18,
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16,2a2.92,2.92,0,0,1,1.42.37l10.2,5.68A2.64,2.64,0,0,1,29,10.32V21.66A2.66,2.66,0,0,1,27.62,24L17.44,29.63A3,3,0,0,1,16,30a3,3,0,0,1-1.43-.37L4.37,24A2.64,2.64,0,0,1,3,21.68V10.34A2.66,2.66,0,0,1,4.38,8L14.56,2.37A3,3,0,0,1,16,2h0m0-2h0a4.93,4.93,0,0,0-2.4.62L3.41,6.3a4.62,4.62,0,0,0-2.41,4V21.68a4.62,4.62,0,0,0,2.41,4l10.18,5.68a5,5,0,0,0,4.82,0L28.59,25.7a4.62,4.62,0,0,0,2.41-4V10.32a4.62,4.62,0,0,0-2.41-4L18.41.62A4.93,4.93,0,0,0,16,0Z",
    fill: "#04A6FC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.35,16.7a4,4,0,0,0,0-.7,5.36,5.36,0,0,0,0-.7l1.52-1.19a.38.38,0,0,0,.09-.46l-1.44-2.49a.37.37,0,0,0-.44-.16l-1.8.72A5.26,5.26,0,0,0,18.07,11l-.27-1.9a.37.37,0,0,0-.36-.31H14.56a.35.35,0,0,0-.35.31L13.94,11a5.12,5.12,0,0,0-1.22.71L10.93,11a.34.34,0,0,0-.44.16L9.05,13.65a.35.35,0,0,0,.09.46l1.53,1.19a4.11,4.11,0,0,0,0,1.4L9.13,17.89a.37.37,0,0,0-.09.46l1.44,2.49a.37.37,0,0,0,.44.16l1.8-.72a5.26,5.26,0,0,0,1.21.71l.27,1.9a.37.37,0,0,0,.36.31h2.88a.35.35,0,0,0,.35-.31l.27-1.9a5.12,5.12,0,0,0,1.22-.71l1.79.72a.36.36,0,0,0,.44-.16L23,18.35a.34.34,0,0,0-.09-.46ZM16,18.7A2.7,2.7,0,1,1,18.7,16,2.7,2.7,0,0,1,16,18.7",
    fill: "#04A6FC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAqaSettingscol);
export default __webpack_public_path__ + "static/media/AQA-Settingscol.8407dd6096598d3e5e507540bac66047.svg";
export { ForwardRef as ReactComponent };